import ErrorCorrectLevel from "../qrcode/ErrorCorrectLevel";

export function errorByText(correctLevel: ErrorCorrectLevel, length: number, icon: boolean, bg: boolean): ErrorCorrectLevel{
	// if(typeof correctLevel !== "undefined"){
	// 	return correctLevel;
	// }

	if((!icon) || (icon && bg)){
		if(length < 39){
			correctLevel = ErrorCorrectLevel.M
		}else{
			correctLevel = ErrorCorrectLevel.L
		}
	}else if(icon && !bg){
		correctLevel = ErrorCorrectLevel.Q
	}else{
		if(length < 39){
			correctLevel = ErrorCorrectLevel.M
		}else{
			correctLevel = ErrorCorrectLevel.L
		}
	}

	return correctLevel;
}